import { parseQueryStringToObj, appendQueryToUrl } from '@shopee/url-util';

export type AuthParams = {
  next?: string;
  client_id?: string;
  redirect_type?: string;
  state?: string;
  initial_phone?: string;
  disable_relogin_redirection?: string;
};

function getAuthParams(): AuthParams {
  const {
    next,
    client_id,
    redirect_type,
    state,
    initial_phone,
    disable_relogin_redirection,
  } = parseQueryStringToObj(location.search);
  return {
    next,
    client_id,
    redirect_type,
    state,
    initial_phone,
    disable_relogin_redirection,
  };
}

export function forwardOrAppendAuthParamsIfNotExist(url: string) {
  const queryObject = getAuthParams();
  return appendQueryToUrl(url, queryObject);
}

export function parseQueryStringToObjInternal(
  queryString?: string | null
): {
  [key: string]: string;
} {
  const urlParams = new URLSearchParams(queryString || '');
  const queryEntries = urlParams.entries();
  let queryObject = {};
  for (const [key, value] of queryEntries) {
    queryObject = { ...queryObject, [key]: value };
  }
  return queryObject;
}

export function parseSpecialCharactersInToCNonce(tocNonce: string) {
  if (tocNonce === '' || tocNonce === null || tocNonce === undefined) {
    return '';
  }
  /**
   * Case 1:
   * URLSearchParams will convert `+` to ` ` (whitespace character)
   * Confirmed with BE @zimu.liu that toc_nonce will not contain whitespace character
   * Source:  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams#preserving_plus_signs
   */
  return tocNonce.replace(/\s/g, '+');
}
